module.exports = __webpack_public_path__ + "img/filter.0169df1f.svg";